import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { CitationEditor } from "../CitationEditor/CitationEditor";
import { CitationList } from "../CitationList/CitationList";
import { Popup } from "../../Common/Popup/Popup";
import * as preact from "preact";

export interface ICitationManagerProps extends IBaseComponentProps
{
     onCitationSelected?: (number)=> void;
     onCitationDeleted?: (number)=> void;
}

export class CitationManager extends BaseComponent<ICitationManagerProps>
{
    private _citationEditor: CitationEditor;
    private _citationIndex: number;
    private _citations: any[];
    private _citationList: CitationList;
    private _popupEditor: Popup;

    constructor(props: ICitationManagerProps)
    {
        super(props);
		this._citations = [];
    }

	public override componentDidMount()
    {
        super.componentDidMount();
		this._citationList.setData(this._citations);
    }

	public setData(citations)
    {
		this._citations = citations || this._citations;
		this._citationList.setData(citations);
    }

	public getData()
	{
		return this._citationList.getData();
	}

	private _onCitationSelect(index)
    {
        this._citationIndex = index;
		this.openEditor(index, true);
	}

	private _onClosePopup()
    {
		this._popupEditor.close();
    }

	private _onCitationComplete(index)
	{
		if(this.props.onCitationSelected && !this._citationEditor.getIsEdit())
		{
			this.props.onCitationSelected(parseInt(index, 10) + 1);
		}
		this._popupEditor.close();
	}

	private _onSaveClick()
    {
        let data = this._citationEditor.getData();
        if (this._citationIndex >= 0)
        {
            this._citations[this._citationIndex] = data;
        }
        else
        {
            this._citations.push(data);
        }
        this._onCitationComplete(this._citations.length - 1);
        this._citationList.renderCitations();
    }

	public openEditor(index?, isEdit?: boolean)
	{
		this._citationIndex = index;
		this._citationEditor.setData(index, this._citations, isEdit);
		this._popupEditor.open();
		this._citationEditor.focus();
    }

    private _onCitationDelete(index)
    {
        if (this.props.onCitationDeleted)
        {
            this.props.onCitationDeleted(index + 1);
        }
    }

	public render()
    {
        return (<div>
            <CitationList ref={(ref) => this._citationList = ref} onSelect={this._onCitationSelect.bind(this)} onDelete={this._onCitationDelete.bind(this)}/>
            <Popup ref={(ref) => this._popupEditor = ref} onClose={this._onClosePopup.bind(this)} >
                <CitationEditor ref={(ref) => this._citationEditor = ref} onCitationComplete={this._onCitationComplete.bind(this)}  />
                <input type="button" onClick={this._onSaveClick.bind(this)} value="Save" />
            </Popup>
		</div>
		);
	}
}